import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface ExtendedIconProps extends IconWrapperProps {
  color?: string;
  svgFill?: string;
}

const CheckIcon = ({ color = '#dd7030', width, svgFill, ...rest }: ExtendedIconProps) => (
  <IconWrapper
    viewBox="0 0 24 24"
    focusable="false"
    title="Check"
    width={width || '24px'}
    height={width || '24px'}
    {...rest}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect
        width="100%"
        height="100%"
        display={svgFill === 'undefined' ? 'none' : 'inherit'}
        fill={svgFill}
      />
      <polygon
        stroke={color}
        fill={color}
        fillRule="nonzero"
        points="9.44911882 15.4206936 6.13018761 12.1017624 5 13.2239909 9.44911882 17.6731097 19 8.12222854 17.8777715 7"
      />
    </g>
  </IconWrapper>
);

export default CheckIcon;
